import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { UserService } from '@app-services/user/user.service';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { NavigationService } from './core/services/navigation.service';
declare var $: any;
declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'student-learning-console';
  token: any;
  
  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private navigationService: NavigationService,
    private gaService: GAnalyticsService,
    private userService: UserService,
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem('token');

    this.route.queryParams.subscribe(params => {
      if(params?.tenant){
        localStorage.setItem('tenantFromUrl', params?.tenant)
      }
    })

    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        
        var currentPage  = event.url.split("/").pop();
        localStorage.setItem('currentPage', currentPage);
        
        this.navigationService.setLocationHistory(event.urlAfterRedirects);
        this.navigationService.getLocationHistory()
        
        // gtag('config', 'G-W5LMXHG10G',
        // {
        //   'page_path': event.urlAfterRedirects,
        //   'cookieDomain': 'none'
        // });
      }
    });
    // document.addEventListener("visibilitychange", () => {
    //   
    //   if (document.hidden) {
    //     this.userService.detectBrowserMinMax.next({hidden: true})
    //   }
    // }, false);
  //   window.addEventListener('blur', function(){
  //     
  //  }, false);
   
  //  window.addEventListener('focus', function(){
  //     
  //  }, false);
  
  window.addEventListener('storage', (event) => {
    if (event.storageArea != localStorage) return;
    if (event.key === 'classEndRefresh') {
      localStorage.removeItem('classEndRefresh');
      window.location.reload();
    }
   });
  }



  // window.ad("beforeunload", (event) => {
  //   localStorage.removeItem('storageVariable');
  // });

  // @HostListener('window:beforeunload', ['$event'])
  // beforeUnloadHandler(event) {
  //   // this.addDailyGoal();
  //   if (!localStorage.getItem('token')) {
  //     this.gaService.sendEvent(
  //       '', '', '', '',
  //       {
  //         'event': 'Close before Sign up',
  //         'User Source': '',
  //         'Session Time': '',
  //       }
  //     )
  //   }
  // }

  // @HostListener('window:beforeunload', ['$event'])
  // unloadNotification($event: any) {
  //   
  //   // this.addDailyGoal();
  //   // if (!this.canDeactivate()) {
  //     //  this.cancelTransaction();
  //       // $event.returnValue = "Are you sure you want close?)";
  //       // window.confirm('are you sure to close browser');
  //   }

  @HostListener('window:beforeunload', ['$event'])
      beforeunloadHandler(event) {
        localStorage.removeItem('feedbackPopupCloased');
        localStorage.removeItem('score-time-slot');
        localStorage.removeItem('stay-clicked');
        localStorage.removeItem('tenantFromUrl');
  }

  endDailyGoal() {
    let userData = JSON.parse(localStorage.getItem('user_details_from_server'));
    const data = {
      createDate: moment(new Date()).format('YYYY-MM-DD'),
      goalTime: JSON.parse(localStorage.getItem('setGoalTime')) || 0,
      spentTime: JSON.parse(localStorage.getItem('setGoalSpendingTime')) || 0,
      userId: userData?.userId
    }
    this.userService.endDailyGoals(data);
  }

  addDailyGoal() {
    let userData = JSON.parse(localStorage.getItem('user_details_from_server'));
    const data = {
      createDate: moment(new Date()).format('YYYY-MM-DD'),
      goalTime: JSON.parse(localStorage.getItem('setGoalTime')) || 0,
      spentTime: JSON.parse(localStorage.getItem('setGoalSpendingTime')) || 0,
      userId: userData?.userId
    }
    this.userService.addDailyGoals(data).subscribe((res: any) => {
      
    })
  }


}
